
import React, { PropsWithChildren, ReactElement, useEffect, useState } from 'react';
import { MappedComponentProperties } from '@adobe/aem-react-editable-components';
import './CreditOneFriends.css';
import { wrapTrademarkSuperscript } from '../../utils/cob-utils';
import { InputBase } from 'component-library/index';
import { transformHTMLParserLinks } from '../../utils/rewriteLink/rewriteLink';
import { Button, Row, Col, Container, TextLine } from '../../importCL';

interface ISocialIcons {
    iconPath: string;
    iconAltText: string;
    link: string;
}

interface ICreditOneFriendsProps extends MappedComponentProperties {
    bgImgPath?: string;
    altText?: string;
    upperText?: string;
    lowerText?: string;
    link?: string;
    savedText?: string;
    copyLinkBtnText?: string;
    twitterText?: string;
    socialFields?: ISocialIcons[];
}

export const CreditOneFriendsEditConfig = {
    emptyLabel: 'Credit One Friends',
    isEmpty: (props: PropsWithChildren<ICreditOneFriendsProps>) => {
        return !props || !props.link;
    },
};

const CreditOneFriends = (props: PropsWithChildren<ICreditOneFriendsProps>): JSX.Element => {
    const { bgImgPath = '', link: initialLink = '', twitterText = '' } = props;
    const [displayFlag, setDisplayFlag] = useState(false);
    const [link, setLink] = useState(initialLink);

    useEffect(() => {
        const url = window.location.href;
        const c1bSpecificationID = new URL(url).searchParams.get('C1BSpecificationID');
        if (c1bSpecificationID && link !== '') {
            const updatedUrl = new URL(link);
            updatedUrl.searchParams.set('C1BSpecificationID', c1bSpecificationID);
            setLink(updatedUrl.toString());
        }
    }, []);

    const getSocialFields = (items: ISocialIcons[] | undefined) => {
        if (!items) {
            return;
        }

        const facebookLink =
            'https://www.facebook.com/sharer/sharer.php?kid_directed_site=0&sdk=joey&u={SHARE_LINK}&display=popup&ref=plugin&src=share_button';
        const twitterLink =
            'https://twitter.com/intent/tweet?original_referer=https%3A%2F%2Fwww.creditonebank.com%2F&ref_src=twsrc%5Etfw%7Ctwcamp%5Ebuttonembed%7Ctwterm%5Eshare%7Ctwgr%5E&text={SHARE_MESSAGE}&url={SHARE_LINK}';

        return items.map((item, index) => {
            let newLink = item.link.toLowerCase().includes('twitter') ? twitterLink : facebookLink;
            newLink = newLink.replace('{SHARE_LINK}', encodeURIComponent(item.link))
                .replace('{SHARE_MESSAGE}', encodeURIComponent(twitterText));
            return (<div key={index} className='my-0 mx-4'>
                <a href={newLink}>
                    <img loading='lazy' className='CreditOneFriends__icon w-auto h-6 hover:cursor-pointer' src={item.iconPath} alt={item.iconAltText} />
                </a>
            </div>);
        });
    };

    const copyToClipBoard = (link: string) => {
        setDisplayFlag(true);
        navigator.clipboard.writeText(link);
        setTimeout(() => {
            setDisplayFlag(false);
        }, 10000);
    };

    return (<div id='credit-one-friends' className='CreditOneFriends'>
        <Container fluid={true} className='!p-0'>
            <Row>
                <Col className='CreditOneFriends__imgContainer !p-0'>
                    <div role='img'
                        className='w-full h-[30rem] max-h-[32rem]'
                        style={{
                            backgroundImage: `${bgImgPath ? ` url("${bgImgPath}")` : ''}`,
                            backgroundSize: 'cover', backgroundPosition: 'center',
                        }}
                        aria-label={props.altText} />
                </Col>
                <Col className='flex justify-center items-center text-center !px-8 !py-12'>
                    <div>
                        <TextLine
                            variant='author'
                            tag='h2'
                            subHeading={transformHTMLParserLinks(wrapTrademarkSuperscript(props.lowerText))}
                            subHeadingClass='font-bold'
                            className='text-start mb-4'>
                            {transformHTMLParserLinks(wrapTrademarkSuperscript(props.upperText))}
                        </TextLine>
                        <InputBase
                            className={`CreditOneFriends__input${displayFlag ? '--reveal' : ''}`}
                            onFocus={() => copyToClipBoard(link)}
                            aria-label='Sharable link'
                            value={link}
                            setValue={() => { }} />
                        <p className={displayFlag ? 'text-green-silver-tree block !mb-4' : ' hidden'}>{transformHTMLParserLinks(wrapTrademarkSuperscript(props.savedText))}</p>
                        <Button onClick={() => copyToClipBoard(link)}>{transformHTMLParserLinks(wrapTrademarkSuperscript(props.copyLinkBtnText)) as unknown as ReactElement}</Button>
                        <div className='flex flex-row justify-center mt-4'>
                            {getSocialFields(props.socialFields)}
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    </div>);
};

//TODO: MVP - Streamline/clean up code to allow for other social link capabilities
export default CreditOneFriends;
